
<div class="cm-backdrop" *ngIf="true" (click)="onBackdropClick($event)">
  <div
    #dialog
    class="cm-dialog"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    [attr.aria-describedby]="message ? messageId : null"
  >
    <h2 class="cm-title" [id]="titleId">{{ title }}</h2>

    <p class="cm-message" *ngIf="message" [id]="messageId">{{ message }}</p>

    <!-- Optional extra content, e.g. a form field or a warning -->
    <div class="cm-body"><ng-content></ng-content></div>

    <div class="cm-actions">
      @if(destructive){
        <button #cancelBtn type="button" class="cm-btn cm-btn--cancel" (click)="onCancel()">
        {{ cancelLabel }}
      </button>
      }      
      <button
        type="button"
        class="cm-btn cm-btn--confirm"
        [class.cm-btn--danger]="destructive"
        (click)="onConfirm()"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</div>